import React from 'react'
import { Row, Col, Modal } from 'react-bootstrap'
import ATSearchBox from '../common/formComponent/ATSearchBox'
import { useTranslation } from 'react-i18next'
import { FaPlusCircle } from 'react-icons/fa'
import '../../pages/customers/Customers.css'
import ATIconButton from '../common/formComponent/ATIconButton'
import ATList from '../common/list/ATList'
import CustomerDetailsForm from './CustomerDetailsForm'
import { CustomersData } from '../../interface/response/CustomerResponse'
import ATLoaderContainer from '../common/loaderContainer/ATLoaderContainer'
import ATModuleMessage from '../common/message/ATModuleMessage'
import Authorize from '../common/auth/Authorize'
import { PERMISSIONS, WIDGET_TYPE } from '../common/auth/AuthorizeConstant'
import { getWidgetMapping } from '../../utils/authUtil/AuthUtil'

interface CustomerListProps {
  handleCustomerSelection: (val: string) => void
  selectedCustomer: string | undefined
  onSearchQueryHandler: (e: React.SyntheticEvent) => void
  filteredList?: CustomersData[]
  query: string
  handleCustomerForm: (val: boolean) => void
  showCustomerDetailsForm: boolean
}

const CustomerList: React.FC<CustomerListProps> = ({
  handleCustomerSelection,
  selectedCustomer,
  onSearchQueryHandler,
  filteredList,
  query,
  handleCustomerForm,
  showCustomerDetailsForm,
}) => {
  const { t } = useTranslation(['translation'])

  const renderList = () => {
    if (filteredList?.length === 0) {
      return (
        <ATLoaderContainer>
          <ATModuleMessage />
        </ATLoaderContainer>
      )
    }
    return (
      <ATList
        data={filteredList}
        valueKey={'customerCode'}
        titleKey={'customerName'}
        selectedItem={selectedCustomer}
        handleSelectedItem={handleCustomerSelection}
      />
    )
  }

  return (
    <Row className="customer-list-container h-100 overflow-auto">
      <Col className="h-100" md={12}>
        <div className="search-bar-container d-flex align-items-center justify-content-between">
          <ATSearchBox
            name="customer"
            handleChange={onSearchQueryHandler}
            onBlurHandler={() => null}
            searchInput={query}
            placeholder={t('customer.search_customers')}
          />
          <div className="px-2">
            <Authorize
              widgetId={getWidgetMapping(PERMISSIONS.ADD_CUSTOMER)}
              widgetType={WIDGET_TYPE.BUTTON}
            >
              <ATIconButton
                variant="primary"
                classes="icon-button"
                icon={<FaPlusCircle size={24} />}
                title={'customer.add'}
                onClick={() => {
                  handleCustomerForm(true)
                }}
              />
            </Authorize>
          </div>
        </div>
        <div className="scroll-list-content">{renderList()}</div>
      </Col>
      <Modal show={showCustomerDetailsForm} className="modal-lg">
        <CustomerDetailsForm
          isEdit={false}
          onCloseModal={() => {
            handleCustomerForm(false)
          }}
        />
      </Modal>
    </Row>
  )
}
export default CustomerList
